import { Button, Flex } from "@/atoms"

import type { TFunction } from "@/hooks/useTranslation"
import type { QuickFilterDropdownProps } from "../.."

export const FooterQuickFilter = (
  props: QuickFilterDropdownProps & { toggle: () => void },
  items: QuickFilterDropdownProps["items"],
  t: TFunction
) => {
  const { toggle, okProps } = props

  if (!items?.length) return []

  const { onClick, ...rest } = okProps

  return [
    { key: "apply_divider", type: "divider" as const },
    {
      key: "apply",
      label: (
        <Flex gap={8} align="center" justify="right">
          <Button
            size="small"
            type="primary"
            onClick={() => {
              onClick()
              toggle()
            }}
            {...rest}
          >
            {t("apply")}
          </Button>
        </Flex>
      )
    }
  ]
}
